let button = `
<a data-gjs-type="link" draggable="true" data-highlightable="1" style="text-align:center; vertical-align: middle; height: 45px; margin: 0 0 0 0; padding: 12px 42px 12px 42px; display: inline-block; font-size: 16px; font-weight: 700; color: #ffffff; background-color: #009fc7; width: 200px; border-radius: 4px 4px 4px 4px; text-decoration: none">
    Button
</a>
`


export {button}
